/* ============================================================
   INDEX PAGE — Phase 4: Count-up + Confetti
   Idea 36: Count-up animation on video gallery stats
   Idea 37: Confetti burst on newsletter subscription success
   ============================================================ */
(function () {
  'use strict';

  /* ── 36. Count-up animation on video gallery stats ── */

  function parseLeadingNumber(text) {
    const m = text.match(/^[\s\u00a0]*([\d,]+)/);
    return m ? parseInt(m[1].replace(/,/g, ''), 10) : null;
  }

  function animateTextNode(node, endVal, duration) {
    const original = node.textContent;
    const match = original.match(/([\d,]+)/);
    if (!match) return;

    const pre = original.slice(0, original.indexOf(match[0]));
    const post = original.slice(original.indexOf(match[0]) + match[0].length);

    const start = 0;
    let startTime = null;

    function step(ts) {
      if (!startTime) startTime = ts;
      const progress = Math.min((ts - startTime) / duration, 1);
      const eased = 1 - Math.pow(1 - progress, 3);
      const current = Math.round(start + (endVal - start) * eased);
      node.textContent = pre + current.toLocaleString() + post;
      if (progress < 1) {
        requestAnimationFrame(step);
      } else {
        node.textContent = original;
      }
    }

    requestAnimationFrame(step);
  }

  function initCountUp() {
    const section = document.getElementById('shopify-section-video_gallery_preview_hPvR3x');
    if (!section) return;

    const stats = Array.prototype.slice.call(section.querySelectorAll('.vgp-stat'));
    if (!stats.length) return;

    let fired = false;
    const observer = new IntersectionObserver(
      function (entries) {
        if (fired) return;
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          fired = true;
          observer.disconnect();

          stats.forEach(function (stat) {
            /* Walk child nodes to find the text node containing the number */
            const nodes = Array.prototype.slice.call(stat.childNodes);
            nodes.forEach(function (node) {
              if (node.nodeType !== Node.TEXT_NODE) return;
              const text = node.textContent;
              const endVal = parseLeadingNumber(text.trim());
              if (endVal && endVal > 1) {
                animateTextNode(node, endVal, 1400);
              }
            });
          });
        });
      },
      { threshold: 0.5 }
    );

    observer.observe(section);
  }

  /* ── 37. Confetti burst on newsletter subscription success ── */

  const CONFETTI_COLORS = ['#c97b5a', '#e8c9a0', '#c9a8b4', '#8a9e7a', '#b89db0', '#f5e9e0'];

  function spawnConfetti(container, originX, originY) {
    const COUNT = 20;
    for (let i = 0; i < COUNT; i++) {
      const dot = document.createElement('span');
      dot.className = 'idx-confetti';

      const angle = (i / COUNT) * 360;
      const dist = 28 + Math.random() * 44;
      const dx = Math.cos((angle * Math.PI) / 180) * dist;
      const dy = Math.sin((angle * Math.PI) / 180) * dist - 18;
      const color = CONFETTI_COLORS[i % CONFETTI_COLORS.length];
      const delay = (i * 0.018).toFixed(3);

      dot.style.cssText =
        'left:' +
        Math.round(originX) +
        'px;' +
        'top:' +
        Math.round(originY) +
        'px;' +
        'background:' +
        color +
        ';' +
        '--cx:' +
        dx.toFixed(1) +
        'px;' +
        '--cy:' +
        dy.toFixed(1) +
        'px;' +
        'animation-delay:' +
        delay +
        's;';

      container.appendChild(dot);
      dot.addEventListener('animationend', function () {
        if (this.parentNode) this.parentNode.removeChild(this);
      });
    }
  }

  function initConfetti() {
    const section = document.getElementById('shopify-section-newsletter_rFpTxK');
    if (!section) return;

    const successEl = section.querySelector('.alert--success');
    if (!successEl) return;

    /* Use rAF to ensure layout is complete before measuring */
    requestAnimationFrame(function () {
      const sectionRect = section.getBoundingClientRect();
      const elRect = successEl.getBoundingClientRect();
      const cx = elRect.left - sectionRect.left + elRect.width / 2;
      const cy = elRect.top - sectionRect.top + elRect.height / 2;
      spawnConfetti(section, cx, cy);
    });
  }

  /* ── Init ── */
  function init() {
    initCountUp();
    initConfetti();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
